var React = require('react');
var SlotMachine = require('../_common/SlotMachine');

var SlotMachineBig = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string
    },

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'Brett Boucher',
                    subtitle: 'PDG Banque d\'investissement',
                    opts: {
                        x: 200,
                        y: 100
                    }
                }
            ],
            backgroundKey: 'bigSlotMachineBg'
        }
    },

    render: function()
    {
        return (
            <SlotMachine
                size={'big'}
                {...this.props}
            />
        );
    }
});

module.exports = SlotMachineBig;



// WEBPACK FOOTER //
// ./js/components/frames/C-TooBig/2-SlotMachineBig.jsx